import CiIcon from '~/vue_shared/components/ci_icon/ci_icon.vue';
/**
 * Component that renders both the CI icon status and the job name.
 * Used in
 *  - Badge component
 *  - Dropdown badge components
 */ export default {
    name: 'JobNameComponent',
    components: {
        CiIcon
    },
    props: {
        name: {
            type: String,
            required: true
        },
        status: {
            type: Object,
            required: true
        },
        iconSize: {
            type: Number,
            required: false,
            default: 16
        }
    }
};
